import WMTS, { optionsFromCapabilities } from "ol/source/WMTS";
import WMTSCapabilities from 'ol/format/WMTSCapabilities.js';
import { ServerLayer } from "../../../lib/layers";
import { Some } from "../../../lib/misc/option";
import Tile from "ol/layer/Tile";
export class WMTSLayer extends ServerLayer {
    constructor(opts) {
        super(opts);
    }
    get layers() {
        return this.raw.map(l => [l]).unwrapOr([]);
    }
    validate(opts) {
        let result = true;
        result && (result = typeof opts.infoUrl === 'string');
        result && (result = Array.isArray(opts.exportUrl) && opts.exportUrl.every(u => typeof u === 'string'));
        result && (result = opts.isBaseLayer !== undefined && opts.visible !== undefined);
        result && (result = typeof opts.isBaseLayer === 'boolean' && typeof opts.visible === 'boolean');
        return result;
    }
    async parse_config(opts) {
        var _a, _b;
        this.is_base = opts.isBaseLayer;
        this.name = opts.name;
        const api = await this.get_service_api(opts.exportUrl);
        if (!api) {
            console.error(`WMTS layer "${opts.name}" loading failed. See console logs.`);
            this.parsing_failed = true;
            return;
        }
        ;
        if (!api.is_cached) {
            console.error(`WMTS layer "${opts.name}" doesn't not have an active tile cache. Loading skipped`);
            this.parsing_failed = true;
            return;
        }
        const wmts_capabilities_url = `${api.endpoints.at(0)}/wmts`;
        const layer = new Tile({
            extent: api.extent,
            opacity: opts.opacity,
            visible: opts.visible,
            source: new WMTS(await parseCapabilitiesToOptions(wmts_capabilities_url, opts.layerId)),
        });
        this.raw = new Some(layer);
        this.projection = api.projection;
        (_a = layer.getSource()) === null || _a === void 0 ? void 0 : _a.on("tileloadstart", () => {
            this.display_loading_indicator(true);
        });
        (_b = layer.getSource()) === null || _b === void 0 ? void 0 : _b.on("tileloadend", () => {
            this.display_loading_indicator(false);
        });
    }
}
const parseCapabilitiesToOptions = async (url, layerId) => {
    const response = await fetch(url);
    const parser = new WMTSCapabilities();
    const result = parser.read(await response.text());
    const options = optionsFromCapabilities(result, {
        layer: layerId !== null && layerId !== void 0 ? layerId : result.Contents.Layer[0].Identifier,
        crossOrigin: 'anonymous',
    });
    return options;
};
